import type { ComponentInternalInstance } from 'vue'

export default class InboxOptionsObserver {
  observers: ComponentInternalInstance[]

  constructor () {
    this.observers = []
  }

  attach (observer: ComponentInternalInstance) {
    this.observers.push(observer)
  }

  closeAllMenus () {
    this.observers.forEach((observer) => {
      observer?.exposed?.closeMenu()
    })
  }
}
